/** Default ISO date pattern used by {@link formatDate} and {@link parseDate}. */
export const dateFormat = "yyyy-MM-dd";

/** Default ISO time pattern used by time helpers. */
export const timeFormat = "HH:mm:ss";
